export default __webpack_public_path__ + "static/media/top10.7aa9e50e.png";